export default __webpack_public_path__ + "static/media/close-in-circle-red.7d80e511.svg";